import { Injectable } from "@angular/core";
import { HttpService } from "../providers/http.service";
import { AppConfig } from "../app/app.config";

@Injectable()
export class ShaBaService {
    constructor(private httpService: HttpService, private AppConfig: AppConfig) { }
    /**
     * 登录沙巴
     */
    login(device: number = 2) {
        let url = AppConfig.GetProdUrl() + "/ShaBa/Login";
        return this.httpService.post(url, { Device: device })
    }

    /**平台转账到沙巴 */
    transferToSb(money: number) {
        let url = AppConfig.GetProdUrl() + "/ShaBa/TransferToSb";
        return this.httpService.post(url, { Amount: money, Type: '0' })
    }

    /**沙巴转账到平台 */
    transferFromSb(money: number) {
        let url = AppConfig.GetProdUrl() + "/ShaBa/TransferFromSb";
        return this.httpService.post(url, { Amount: money, Type: '1' })
    }

    /**获取沙巴余额 */
    getBalance() {
        let url = AppConfig.GetProdUrl() + "/ShaBa/GetBalance";
        return this.httpService.post(url, '');
    }

    /**获取转账记录 */
    getTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/ShaBa/GetTransferList";
        return this.httpService.post(url, params);
    }

    /**获取投注记录 */
    getBettingList(params) {
        let url = AppConfig.GetProdUrl() + "/ShaBa/GetBettingList";
        return this.httpService.post(url, params);
    }


}



// WEBPACK FOOTER //
// ./src/services/shaba.service.ts